interface SeoMetaConfig {
  title: string;
  description: string;
  canonicalPath?: string;
  robots?: string;
}

const BASE_URL = "https://ict-classroom.mangosorange.com";
const DEFAULT_ROBOTS = "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1";

const upsertMetaTag = (attribute: "name" | "property", key: string, content: string) => {
  const selector = `meta[${attribute}="${key}"]`;
  let metaTag = document.head.querySelector(selector) as HTMLMetaElement | null;

  if (!metaTag) {
    metaTag = document.createElement("meta");
    metaTag.setAttribute(attribute, key);
    document.head.appendChild(metaTag);
  }

  metaTag.content = content;
};

const upsertCanonicalLink = (href: string) => {
  let canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.href = href;
};

const resolveCanonicalUrl = (path?: string) => {
  try {
    return new URL(path ?? "/", `${BASE_URL}/`).toString();
  } catch {
    return `${BASE_URL}/`;
  }
};

export const applySeoMeta = ({ title, description, canonicalPath, robots }: SeoMetaConfig) => {
  const canonicalUrl = resolveCanonicalUrl(canonicalPath);
  const robotsPolicy = robots ?? DEFAULT_ROBOTS;

  document.title = title;

  upsertMetaTag("name", "description", description);
  upsertMetaTag("name", "robots", robotsPolicy);
  upsertCanonicalLink(canonicalUrl);

  upsertMetaTag("property", "og:type", "website");
  upsertMetaTag("property", "og:site_name", "ICT Classroom Monitoring Dashboard");
  upsertMetaTag("property", "og:title", title);
  upsertMetaTag("property", "og:description", description);
  upsertMetaTag("property", "og:url", canonicalUrl);

  upsertMetaTag("name", "twitter:card", "summary");
  upsertMetaTag("name", "twitter:title", title);
  upsertMetaTag("name", "twitter:description", description);
};
